export const SUPPORT_RECORD_ROLES = ["Principal", "Hostel Supervisor", "Warden"];

export const canAccessSupportRecords = (user) => (
  user?.role === "admin" || SUPPORT_RECORD_ROLES.includes(user?.staff_role)
);

const FINANCIAL_EXCLUDED_ROLES = new Set(["visitor", "guard", "general worker", "dining hall supervisor"]);

export const canAccessFinancial = (user) => {
  if (user?.role === "admin") return true;
  const role = String(user?.role || "").trim().toLowerCase();
  const staffRole = String(user?.staff_role || role).trim().toLowerCase();
  return role !== "visitor" && !FINANCIAL_EXCLUDED_ROLES.has(staffRole);
};

export const canManageFinancialLedger = (user) => (
  String(user?.role || "").trim().toLowerCase() === "admin"
  || String(user?.staff_role || user?.role || "").trim().toLowerCase() === "hostel supervisor"
);

export const canApproveFinancialRequests = (user) => {
  const role = String(user?.role || "").trim().toLowerCase();
  const staffRole = String(user?.staff_role || role).trim().toLowerCase();
  return role === "admin" || staffRole === "principal" || staffRole === "hostel supervisor";
};

export const canDeleteFinancialRequests = (user) => (
  String(user?.role || "").trim().toLowerCase() === "admin"
  || String(user?.staff_role || user?.role || "").trim().toLowerCase() === "hostel supervisor"
);